import React from 'react';
import PropTypes from 'prop-types';

import HorseDefinition from '../../../shared/HorseDefinition';

const Dam = ({
    damHorseName,
    damUid,
    damCountryOriginCode,
}) => (
    <HorseDefinition
        countryOriginCode={damCountryOriginCode}
        horseName={damHorseName}
        horseUid={damUid}
        term="Dam"
    />
);

Dam.propTypes = {
    damHorseName: PropTypes.string,
    damUid: PropTypes.number,
    damCountryOriginCode: PropTypes.string,
};

export default Dam;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Dam.jsx